export default {
  name: 'ConnectionsListItemAdditionalInfo',

  props: {
    connection: {
      type: Object,
      default: () => ({}),
    },
  },
};
